import React from 'react';
import Reveal from './Reveal';

const universities = [
  'Imperial College London',
  'University of Cambridge',
  'UCL',
  'University of Oxford',
  'University of Edinburgh',
  'University of Warwick',
  'King’s College London',
  'University of Bristol',
];

const stats = [
  { value: '1 in 8', label: 'applicants accepted as tutors' },
  { value: '30+', label: 'subjects from KS2 to A Level' },
  { value: '24h', label: 'average time to first match' },
  { value: '4.9/5', label: 'average session rating' },
];

const TrustStrip: React.FC = () => (
  <section className="border-y border-ink-900/[0.07] bg-base-200/50 dark:border-white/[0.07]">
    <div className="py-12 sm:py-14">
      <p className="section-shell text-center text-xs font-semibold uppercase tracking-[0.16em] text-base-content/45">
        Tutors from the UK&rsquo;s leading universities
      </p>

      <div className="mask-fade-edges relative mt-7 overflow-hidden">
        <div className="flex w-max animate-marquee gap-12 pr-12">
          {[0, 1].map((pass) => (
            <div key={pass} className="flex shrink-0 gap-12" aria-hidden={pass === 1}>
              {universities.map((name) => (
                <span
                  key={name}
                  className="whitespace-nowrap text-lg font-semibold text-base-content/35 sm:text-xl"
                >
                  {name}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="section-shell mt-12 grid grid-cols-2 gap-x-6 gap-y-9 sm:mt-14 lg:grid-cols-4">
        {stats.map((stat, i) => (
          <Reveal key={stat.label} delay={i * 0.07}>
            <div className="text-center">
              <p className="display text-4xl text-brand-600 sm:text-5xl dark:text-brand-400">
                {stat.value}
              </p>
              <p className="mx-auto mt-2 max-w-[13rem] text-sm text-base-content/55">
                {stat.label}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default TrustStrip;
